/* eslint-disable no-unused-vars */
export enum Role {
  OP = "OP",
  RP = "RP",
}
